import * as React from "react";
const SvgFiRrFaceSmileTongue = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-smile-tongue_svg__a)">
      <path
        fill="#062147"
        d="M6 12a1 1 0 0 1-1-1c0-1.892 1.232-4 3-4s3 2.108 3 4a1 1 0 0 1-2 0c0-1.054-.679-2-1-2s-1 .946-1 2a1 1 0 0 1-1 1m12.466 4.161c.836 1.383.768 3.486-.818 4.445a2.7 2.7 0 0 1-1.404.395c-1.18 0-2.318-.753-2.922-1.753l-.767-1.27a7 7 0 0 1-.555.021c-3.107 0-5.563-2.162-5.666-2.254a1 1 0 0 1 1.33-1.494c.022.02 2.006 1.748 4.336 1.748 2.35 0 4.068-1.527 4.085-1.542a.997.997 0 0 1 1.535.241zm-1.722 1.019-.301-.521a9.3 9.3 0 0 1-1.819.879l.409.677c.342.567 1.075.987 1.58.681.504-.305.474-1.15.131-1.716M15.999 7c-1.768 0-3 2.108-3 4a1 1 0 0 0 2 0c0-1.054.679-2 1-2s1 .946 1 2a1 1 0 0 0 2 0c0-1.892-1.232-4-3-4M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12c.733 0 1.467-.066 2.181-.198a1 1 0 0 0-.361-1.967c-.595.109-1.207.165-1.819.165-5.514 0-10-4.486-10-10S6.486 2 12 2s10 4.486 10 10c0 1.601-.367 3.13-1.09 4.545a1.001 1.001 0 0 0 1.782.91 11.9 11.9 0 0 0 1.309-5.456C24 5.383 18.617 0 12 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-smile-tongue_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceSmileTongue;
